module.exports = __FOREMAN_VENDOR__REACT_LOADING_SKELETON__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_LOADING_SKELETON__"
// module id = react-loading-skeleton
// module chunks = 0 1 2